import { ChangeEvent } from 'react'
import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

interface Props {
  search: string
  onSearch: (event: ChangeEvent<HTMLInputElement>) => void
}

export const RequestsDataTable = ({ search, onSearch }: Props) => {
  return (
    <Box gap="s8">
      <DataTable.HeadBar
        exportFileName={i18n.t('trainings.requests_export_name')}
        search={{
          value: search,
          onChange: onSearch,
          placeholder: i18n.t('common.search'),
        }}
      />
      <DataTable.Table />
      <Outlet />
    </Box>
  )
}
